// Client copy, transcribed verbatim — punctuation and wording as supplied.
export default {
  statement: {
    id: 'rm_take_action_callout_statement',
    defaultMessage:
      'The most sustainable phone is the one that already exists.',
  },
  body: {
    id: 'rm_take_action_callout_body',
    defaultMessage:
      'Back Market is fighting for a world where phones last for 10 years, through care, repair, reuse and refurbishment.',
  },
  cta: {
    id: 'rm_take_action_callout_cta',
    defaultMessage: 'Take Action',
  },
} as const
